<template>
  <div class="card relative">
    <div v-if="refresh && timeserchtype==='...'" @click="Refrechdata(action)" class="vld-overlay-refrech">
            <div class="vld-background" style="backdrop-filter: blur(2px);"></div>
            <button  class="btnn box flex items-center text-gray-700 dark:text-gray-300 cursor-not-allowed pointer-events-none">
                <img class="analytics-imgg" src="https://img.icons8.com/office/80/000000/refresh--v1.png"/> Refresh 
            </button>
       </div>
    <div class="card-header">
     
           

           <div class="relative text-slate-500 w-full" v-if="filter">
              <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name" class="mb-5 -m-4 relative border mt-1 border-gray-600 border-dashed justify-start">
                <div class="flex items-center space-x-1 sm:space-x-1 p-1">
                  <div class="flex www-3/7" v-if="currentUser.role.name!='Seller' && currentUser.type!='Seller'">
                      <div class="flex w-full">
                              <div class="w-10 z-1 pl-1 text-center pointer-events-none flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="15" class="text-gray-600 fill-current" height="15" viewBox="0 0 24 24"><path d="M12 2c2.757 0 5 2.243 5 5.001 0 2.756-2.243 5-5 5s-5-2.244-5-5c0-2.758 2.243-5.001 5-5.001zm0-2c-3.866 0-7 3.134-7 7.001 0 3.865 3.134 7 7 7s7-3.135 7-7c0-3.867-3.134-7.001-7-7.001zm6.369 13.353c-.497.498-1.057.931-1.658 1.302 2.872 1.874 4.378 5.083 4.972 7.346h-19.387c.572-2.29 2.058-5.503 4.973-7.358-.603-.374-1.162-.811-1.658-1.312-4.258 3.072-5.611 8.506-5.611 10.669h24c0-2.142-1.44-7.557-5.631-10.647z"/></svg></div>
                                <v-select
                                @search="getUsersDebance($event,'shipsen')"
                                @input="CheckSellerProducts($event,action,'seller')"
                                label="fullName"
                                placeholder="Seller ..."
                                :options="sellers"
                                v-model="sellerdata"

                                class="text-gray-600 shadow bg-white w-full -ml-10 pl-8 py-1 rounded-lg border-2 border-gray-200 outline-none focus:border-indigo-500"
                              
                              ></v-select>
                      </div>
                  </div>
                  <div class="flex" :class="currentUser.type!='Seller'?'www-3/7':'w-10/12'">
                        <div class="flex mx-1 w-full">
                          <div class="w-10 z-1 pl-1 text-center pointer-events-none flex items-center justify-center">
                            <svg class="text-gray-600 fill-current" width="15"   height="15" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24"><path d="M11.5 23l-8.5-4.535v-3.953l5.4 3.122 3.1-3.406v8.772zm1-.001v-8.806l3.162 3.343 5.338-2.958v3.887l-8.5 4.534zm-10.339-10.125l-2.161-1.244 3-3.302-3-2.823 8.718-4.505 3.215 2.385 3.325-2.385 8.742 4.561-2.995 2.771 2.995 3.443-2.242 1.241v-.001l-5.903 3.27-3.348-3.541 7.416-3.962-7.922-4.372-7.923 4.372 7.422 3.937v.024l-3.297 3.622-5.203-3.008-.16-.092-.679-.393v.002z"/></svg>
                          </div>
                            <v-select
                            @search="getProducts($event,'shipsen')"
                            @input="CheckSellerProducts($event,action,'product')"
                            label="name"
                            placeholder="Product name ..."
                            :options="products"
                            v-model="productdata"
                            class="text-gray-600 shadow bg-white w-full -ml-10 pl-8 py-1 rounded-lg border-2 border-gray-200 outline-none focus:border-indigo-500"
                          ></v-select>
                      </div>
                  </div>
                  <div class="flex www-3/7 w-full shadow bg-white rounded-lg border-2 border-gray-200">
                 
               
                 <select  id="type"
                       :name="action"
                       autocomplete="type"
                       @change="ChangeDateConfirmation($event)"
                       v-model="timeserchtype"
                       class="text-gray-600 w-full px-2 py-2 bg-white   outline-none focus:border-indigo-500"
                     >
                       >
                       <option class="bg-white text-gray-600" value="all">
                         All
                       </option>
                       <option class="bg-white text-gray-600" value="today">
                         Today
                       </option>
                       <option class="bg-white text-gray-600" value="yesterday">Yesterday</option>
                       <option class="bg-white text-gray-600" value="thisweek">This week</option>
                     <option class="bg-white text-gray-600" value="lastweek">Last week</option>
                       <option class="bg-white text-gray-600" value="thismonth">
                         This Month
                       </option>
                       <option class="bg-white text-gray-600" value="lastmonth">
                         Last Month
                       </option> 
                       <option class="bg-white text-gray-600" value="thisyear">
                         This Year
                       </option>
                       <option class="bg-white text-gray-600" value="betweendate">
                         Between  date
                       </option>
                     </select>
                  
               </div>
                  <div class="wwww-1/7 flex justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg"  @click="removedata(action)"  class="text-gray-600 fill-current cursor-pointer" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z"/></svg>
                      <!-- <svg :class="!sellerdata && currentUser.role.name!='Seller' && currentUser.type!='Seller'?'btn-disable':''" @click="FindRecordsSellers" xmlns="http://www.w3.org/2000/svg" class="text-gray-600 fill-current cursor-pointer"  width="24" height="24" viewBox="0 0 24 24"><path d="M23.111 20.058l-4.977-4.977c.965-1.52 1.523-3.322 1.523-5.251 0-5.42-4.409-9.83-9.829-9.83-5.42 0-9.828 4.41-9.828 9.83s4.408 9.83 9.829 9.83c1.834 0 3.552-.505 5.022-1.383l5.021 5.021c2.144 2.141 5.384-1.096 3.239-3.24zm-20.064-10.228c0-3.739 3.043-6.782 6.782-6.782s6.782 3.042 6.782 6.782-3.043 6.782-6.782 6.782-6.782-3.043-6.782-6.782zm2.01-1.764c1.984-4.599 8.664-4.066 9.922.749-2.534-2.974-6.993-3.294-9.922-.749z"/></svg> -->
                  </div>
                </div>
                <div v-if="filter && timeserchtype=='betweendate'" class="p-1">
                  <!-- <div class="inline-block mt-2 w-2/5 pr-1">
                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">From <span class="text-blue-500">*</span></label></p></div>
                          <p>  <input :name="action" v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date"> </p>
                      </div>
                  </div>
                  <div class="inline-block mt-2 w-2/5 pr-1">
                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">To <span class="text-blue-500">*</span></label></p></div>
                          <p>  <input :name="action" v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"> </p>
                      </div>
                  </div> -->
                  <div class="flex items-center space-x-2 sm:space-x-2">
                    <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="w-full-imp  shadow" v-model="fromDate" range></date-picker>
                      <!-- <button @click="FindRecordsBetweenDate()" :disabled="fromDate==null || toDate==null" class="w-full py-2 text-white font-light tracking-wider bg-gray-900 rounded">Find</button> -->
                      <svg @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="text-gray-600 fill-current cursor-pointer" width="24" height="24" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15.985 17.031c-1.479 1.238-3.384 1.985-5.461 1.985-4.697 0-8.509-3.812-8.509-8.508s3.812-8.508 8.509-8.508c4.695 0 8.508 3.812 8.508 8.508 0 2.078-.747 3.984-1.985 5.461l4.749 4.75c.146.146.219.338.219.531 0 .587-.537.75-.75.75-.192 0-.384-.073-.531-.22zm-5.461-13.53c-3.868 0-7.007 3.14-7.007 7.007s3.139 7.007 7.007 7.007c3.866 0 7.007-3.14 7.007-7.007s-3.141-7.007-7.007-7.007zm.741 8.499h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm3-2.5h-7.5c-.414 0-.75.336-.75.75s.336.75.75.75h7.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75zm0-2.5h-7.5c-.414 0-.75.336-.75.75s.336.75.75.75h7.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z" fill-rule="nonzero"/></svg>
                  </div>  
              </div>
          </div>
           
          </div>
          <div class="intro-y block sm:flex items-center">
            <span><img class="analytics-img" src="https://img.icons8.com/cotton/64/000000/percentage--v3.png"/> {{statSubtitle}}  </span>
        </div>

    </div>
    <ul v-if="dataChart" class="list-group list-group-flush relative">
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <li v-for="(item, index) in dataChart" :key="index" class="list-group-item bg-transparent">
           <div  class="media align-items-center">
              <span class="circle-range" :style="'border-color: '+item.colors+' !important;'"></span>
              <div  class="media-body ml-3"><h6  class="mb-0 capitalize font-semibold">{{item.name=='Unreached'?'Pending Unreached':item.name}}</h6><p  class="mb-0 font-semibold">{{item.count}}</p></div>
              <div class="star"><div :id="(item.name).toLowerCase()"></div></div>
            </div>
        </li>
    </ul>   
   </div>
</template>
<script>
export default {
  name: "card-stats-v4",
  props: {
    statSubtitle: {
      default: "Traffic",
    },
    loading:{required:false},
    timeserch:{},
    titleRate:{},
    from:{},
    to:{},
    filter: {
      default: false,
    },
    statTitle: {},
    action: {},
    statArrow: {
      default: "up",
      validator: function (value) {
        // The value must match one of these strings
        return ["up", "down"].indexOf(value) !== -1;
      },
    },
    statPercent: {},
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      default: "text-green-500",
    },
    statDescripiron: {},
    id:{type:String},
    color:{type:String},
    currency: {default:false},
    count:{type: Number,default:0},
    datas:{type:Object},
    dataChart:{type:Array},
    countText:{},
    refresh: {
      default: false,
    },
    rate:{},
    statIconName: {
      default: "far fa-chart-bar",
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
    seller:{},
   product:{},
   sellers:{type:Array},
   products:{type:Array},
   currentUser:{type:Object},
    filterseller: {
      default: false,
    },
  },
  data() {
    return {
      fullPage: false,
      myChart: "lll",
      myChartALL: ["","","","",""],
      timeserchtype:this.timeserch,
      fromDate:this.from,
      toDate:this.to,
      sellerdata:this.seller,
      productdata:this.product,
    };
  },
  watch: {
    'timeserch': function () {
      this.timeserchtype=this.timeserch;
    },
    'seller': function () {
      this.sellerdata=this.seller;
   },
   'product': function () {
      this.productdata=this.product;
   },
    dataChart: function () {
      if (this.myChartALL.length>0 && this.myChartALL[0]) {
        for (let i in this.myChartALL) {
              this.myChartALL[i].destroy();
        }
      }
      this.drawChart(this.dataChart);
      for (let i in this.myChartALL) {
          this.myChartALL[i].render();
        }
    },
  },
  async mounted(){
     await this.drawChart(this.dataChart);
     if (this.myChartALL.length>0 && this.myChartALL[0]) {
        for (let i in this.myChartALL) {
             this.myChartALL[i].render();
        }
     }
  },
   methods: {
    ChangeDateConfirmation: function (val) {
      this.$emit("ChangeDateConfirmation", val);
    },
    Refrechdata: function (val) { 
        this.$emit("Refrechdata", val);
    },
    ChangeDateCallcenter: function (val) {
         this.$emit("ChangeDateCallcenter", val);
    },
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
      FindRecordsSellers: function (val) {
        this.$emit("FindRecordsSellers", this.action,this.sellerdata,this.productdata);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    getProducts: function (name) {
        this.$emit("getProducts", name);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    drawChart(chartData) {
        for (let i in chartData) {
            this.myChartALL[i] = new ApexCharts(document.getElementById((chartData[i].name).toLowerCase()), {
              chart: {
                height: 110,
                width:90,
                type: 'radialBar',
                toolbar: {
                  show: false
                }
              },
              plotOptions: {
                radialBar: {
                  //startAngle: -135,
                  //endAngle: 225,
                  hollow: {
                    margin: 0,
                    size: '70%',
                    background: '#fff',
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: 'front',
                    dropShadow: {
                      enabled: true,
                      top: 3,
                      left: 0,
                      blur: 4,
                      opacity: 0.24
                    }
                  },
                  track: {
                    background: '#fff',
                    strokeWidth: '67%',
                    margin: 0, // margin is in pixels
                    dropShadow: {
                      enabled: true,
                      top: -3,
                      left: 0,
                      blur: 4,
                      opacity: 0.35
                    }
                  },
                  dataLabels: {
                    showOn: 'always',
                    name: {
                      offsetY: -0,
                      show: false,
                      color: 'rgba(0, 0, 0, 0.84)',
                      fontSize: '16px'
                    },
                    value: {
                      formatter: function (val) {
                        return val + "%";
                      },
                      offsetY: 8,
                      color: 'rgba(0, 0, 0, 0.84)',
                      fontSize: '19px',
                      show: true,
                    }
                  }
                }
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shade: 'light',
                  type: 'horizontal',
                  shadeIntensity: 0.5,
                  gradientToColors: [chartData[i].gradient],
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
                }
              },
              colors: [chartData[i].colors],
              series: [chartData[i].percent],
              stroke: {
                lineCap: 'round'
              },
              labels: ['Percent'],
              responsive: [{
                breakpoint: 480,
                options: {
                  chart: {
                    height: 230
                  }
                }
              }]
            });
      }
       
    },
   }
};
</script>
<style scoped>
.circle-range {
    width: 20px;
    height: 20px;
    background: #fff;
    border: 7px solid;
    border-radius: 50%;
    margin-right: 15px;
}
.card > .list-group:last-child {
    background-color: #fff;
    border-bottom-width: 0;
    border-bottom-right-radius: calc(.25rem - 1px);
    border-bottom-left-radius: calc(.25rem - 1px);
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    /* box-shadow: 0 .125rem .25rem rgba(0,0,0,.075); */
}
.card-header + .list-group .list-group-item:first-child {
    border-top: 0;
}
.list-group-flush > .list-group-item:last-child {
    border-bottom-width: 0;
}
.list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit;
}
.align-items-center {
    align-items: center;
}
.media {
    display: flex;
    align-items: flex-start;
}
.customer-img {
    height: 55px;
}
.rounded-circle {
    border-radius: 50% !important;
}
.small-font {
    font-size: 14px;
}
.list-group-item {
    position: relative;
    height: 85px;
    display: block;
    padding: 0 1.25rem;
    color: #383838;
    border: 1px solid rgba(0,0,0,.1);
} 
.list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}
.list-group-flush > .list-group-item {
    border-width: 0 0 1px;
}
.card-header:first-child {
    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
}
.card-action {
    float: right;
    margin-top: 10px;
}
.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
}
.card-header {
    padding: .90rem 1.25rem;
    margin-bottom: 0;
    background: transparent;
    border-bottom: 1px solid rgba(0,0,0,.08);
    font-weight: 600;
    font-size: 16px;
    color: rgba(0,0,0,.84);
    padding-top: 0;
}
.card {
    margin-bottom: 25px;
    box-shadow: 0 5px 15px rgba(57,98,254,.02),0 3px 6px rgba(117,108,254,.12);
    border: none;
    background-color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: initial;
    border-radius: .25rem;
    flex: 1 1 auto;
    min-height: 1px;
}
</style>
